import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  EMPLOYEES_LIST_PERMISSIONS,
  EMPLOYEES_MAIN_ROUTE_NAME,
} from '@modules/employees/constants';
import {
  EMPLOYEES_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_EMPLOYEES_EDIT,
} from '@modules/employees/submodules/edit/constants';
import { getTranslationKeys } from '@modules/employees/submodules/edit/translations';

export class EmployeesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(EMPLOYEES_MAIN_ROUTE_NAME, {
      name: EMPLOYEES_EDIT_ROUTE_NAME,
      path: 'edit/:id',
      component: () => import('@modules/employees/submodules/edit/pages/EmployeeEditPage/EmployeeEditPage.vue'),
      permission: EMPLOYEES_LIST_PERMISSIONS.EDIT,
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_EMPLOYEES_EDIT, getTranslationKeys);
  }
}
